export default __webpack_public_path__ + "static/media/IBM.a26a465c.png";